export default "__VITE_ASSET__4d484ec0__"